module.exports = __webpack_public_path__ + "static/media/S (189).524157a7.jpg";